import { captureTrafficSource } from '~/composables/useTrafficSource';

export default defineNuxtPlugin(() => {
  captureTrafficSource();
});
